/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfBlogCategoryListItemDto } from '../../models/paginated-dto-of-blog-category-list-item-dto';

export interface GetCategoriesList$Params {
}

export function getCategoriesList(http: HttpClient, rootUrl: string, params?: GetCategoriesList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfBlogCategoryListItemDto>> {
  const rb = new RequestBuilder(rootUrl, getCategoriesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfBlogCategoryListItemDto>;
    })
  );
}

getCategoriesList.PATH = '/api/v1/blog/categories';
